export const beaaAdminGreeting =
  'Olá! Eu sou a Beaa, assistente deste Console. Por aqui eu te oriento sobre o acesso (primeiro acesso, senha provisória, segundo fator e recuperação de senha), explico os módulos e reforço as boas práticas de segurança. Este é um ambiente técnico e auditado.';

export const beaaAdminSuggestions = [
  { id: 'adm-sug-primeiro-acesso', icon: 'ri-login-circle-line', label: 'Como faço o primeiro acesso?' },
  { id: 'adm-sug-senha', icon: 'ri-lock-password-line', label: 'Esqueci minha senha, e agora?' },
  { id: 'adm-sug-mfa', icon: 'ri-shield-keyhole-line', label: 'O que é o segundo fator (MFA)?' },
  { id: 'adm-sug-modulos', icon: 'ri-apps-2-line', label: 'Quais módulos tem no Console?' },
  { id: 'adm-sug-petbea', icon: 'ri-information-line', label: 'O que é o PETBEA?' },
  { id: 'adm-sug-seguranca', icon: 'ri-lock-line', label: 'Boas práticas de segurança' },
];

/** Saudação da Beaa na etapa de ativação do acesso (primeiro acesso e troca de senha). */
export const beaaAdminAcessoGreeting =
  'Olá! Estamos ativando o seu acesso ao Console. Eu te ajudo a escolher uma senha forte, a entender por que a senha provisória precisa ser trocada e o que a política de uso significa. Pode me perguntar.';

/** Sugestões da Beaa na etapa de ativação do acesso. */
export const beaaAdminAcessoSuggestions = [
  { id: 'adm-ace-senha-forte', icon: 'ri-lock-password-line', label: 'Como criar uma senha forte?' },
  { id: 'adm-ace-provisoria', icon: 'ri-refresh-line', label: 'Por que trocar a senha provisória?' },
  { id: 'adm-ace-politica', icon: 'ri-file-shield-2-line', label: 'O que é a política de uso?' },
  { id: 'adm-ace-mfa', icon: 'ri-shield-keyhole-line', label: 'Preciso do segundo fator (MFA)?' },
  { id: 'adm-ace-convite', icon: 'ri-mail-close-line', label: 'Meu convite expirou, o que faço?' },
  { id: 'adm-ace-ajuda', icon: 'ri-customer-service-2-line', label: 'Não consigo avançar, e agora?' },
];

export const beaaAdminKnowledge = [
  {
    id: 'adm-saudacao',
    keywords: ['oi', 'ola', 'bom dia', 'boa tarde', 'boa noite', 'tudo bem', 'opa', 'e ai'],
    answer:
      'Olá! Que bom te ver por aqui. Eu posso te ajudar com o acesso ao Console (primeiro acesso, senha e segundo fator), explicar os módulos e lembrar as boas práticas de segurança. Sobre o que você quer saber?',
    actions: [],
  },
  {
    id: 'adm-primeiro-acesso',
    keywords: [
      'primeiro acesso',
      'primeiro login',
      'acesso inicial',
      'senha provisoria',
      'senha temporaria',
      'trocar a senha',
      'troca de senha',
      'primeira vez',
    ],
    answer:
      'No primeiro acesso, o administrador cria a sua conta com uma senha provisória. Ao entrar pela primeira vez, o Console te leva direto para definir uma nova senha — a provisória deixa de valer logo depois. Escolha uma senha longa, única e que só você conheça.',
    actions: [],
  },
  {
    id: 'adm-recuperar-senha',
    keywords: [
      'esqueci',
      'recuperar',
      'redefinir',
      'nova senha',
      'resetar',
      'nao lembro a senha',
      'perdi a senha',
      'esqueci a senha',
    ],
    answer:
      'Sem problema. Na tela de login, toque em "Esqueceu a senha?", informe o seu e-mail institucional e enviaremos um link para criar uma nova senha. O link é de uso único e expira rápido — nunca compartilhe esse link com ninguém.',
    actions: [],
  },
  {
    id: 'adm-mfa',
    keywords: [
      'mfa',
      'segundo fator',
      '2fa',
      'autenticador',
      'codigo',
      'codigo de 6',
      'totp',
      'autenticacao',
    ],
    answer:
      'O segundo fator (MFA) adiciona uma camada extra de proteção: além da senha, pedimos um código de 6 dígitos gerado pelo seu aplicativo autenticador. Você ativa pelo menu Segurança. Se perder o acesso ao aplicativo, peça ajuda a um administrador do sistema para reconfigurar.',
    actions: [],
  },
  {
    id: 'adm-modulos',
    keywords: [
      'modulos',
      'modulo',
      'menu',
      'o que tem',
      'funcionalidades',
      'sistema',
      'telas',
      'o que da pra fazer',
    ],
    answer:
      'O Console reúne, entre outros, os módulos: Cadastros (Pessoas e Organizações), Rede de Proteção (Protetores, Cuidadores, Acompanhamentos, Credenciamentos e Vistorias), Saúde Animal e Cadernetas, UPAVET, Adoção, Campanhas, BAA (insumos e estoque), Castrômetro, Território, Analytics e Gestão (Usuários, Auditoria e Segurança). O que você vê depende das suas permissões.',
    actions: [],
  },
  {
    id: 'adm-cadastros',
    keywords: ['cadastro', 'cadastros', 'pessoa', 'pessoas', 'organizacao', 'cnpj', 'cpf', 'tutor'],
    answer:
      'No módulo Cadastros ficam as Pessoas e as Organizações. Cada pessoa é um único cadastro mestre (identificado pelo CPF); organizações formais têm CNPJ e coletivos informais não. Perfis e vínculos ficam ligados à MESMA pessoa, sem duplicar registros.',
    actions: [],
  },
  {
    id: 'adm-rede-protecao',
    keywords: [
      'rede de protecao',
      'protetor',
      'protecao',
      'cuidador',
      'credenciamento',
      'vistoria',
      'acompanhamento',
      'ong',
    ],
    answer:
      'A Rede de Proteção reúne Protetores Independentes, Cuidadores Comunitários, ONGs e Organizações, além de Credenciamentos, Vistorias e Acompanhamentos. Vale lembrar: estar cadastrado é diferente de estar credenciado — só após a aprovação a pessoa passa a constar como credenciada.',
    actions: [],
  },
  {
    id: 'adm-baa',
    keywords: ['baa', 'insumo', 'insumos', 'estoque', 'cotacao', 'medicamento', 'entrega', 'raca'],
    answer:
      'O módulo BAA cuida dos insumos e do estoque do bem-estar animal — categorias, unidades de medida, cotações, medicamentos, protocolos, distribuições e entregas. Os saldos e as movimentações ficam registrados para auditoria.',
    actions: [],
  },
  {
    id: 'adm-naa',
    keywords: ['naa', 'uapa', 'campanha', 'triagem', 'atendimento', 'projeto', 'programa', 'mutirao'],
    answer:
      'O módulo NAA (Núcleo de Apoio e Atendimento) organiza projetos, programas, campanhas, mutirões, metas, triagens, inscrições e atendimentos. Esses registros também alimentam o histórico e os indicadores do bem-estar animal.',
    actions: [],
  },
  {
    id: 'adm-auditoria',
    keywords: ['auditoria', 'log', 'registro', 'historico', 'trilha', 'rastreavel', 'rastreabilidade'],
    answer:
      'As ações relevantes ficam registradas na Auditoria: quem fez, o que fez, quando, de onde acessou e em nome de quem. Por isso este é um ambiente rastreável — o que você realiza por aqui pode ser consultado depois. Use sempre a sua própria conta.',
    actions: [],
  },
  {
    id: 'adm-institucional',
    keywords: [
      'petbea',
      'pet bea',
      'amma',
      'municipio',
      'prefeitura',
      'programa',
      'o que e isso',
      'o que e o petbea',
      'gestao',
    ],
    answer:
      'O PETBEA é a plataforma de gestão do bem-estar animal da Prefeitura de Goiânia, conduzida pela AMMA. Uma única base integra pessoas, animais, organizações, UPAVET e políticas públicas. O Console Administrativo é a operação interna dessa plataforma — a mesma origem dos dados do portal do cidadão.',
    actions: [],
  },
  {
    id: 'adm-permissoes',
    keywords: [
      'permissao',
      'não consigo ver',
      'nao consigo ver',
      'nao tenho acesso',
      'negado',
      'sem acesso',
      'nao aparece',
      'bloqueado',
    ],
    answer:
      'O Console usa permissões por recurso e ação. Se um módulo ou botão não aparece, provavelmente o seu papel não tem aquela permissão. Nesse caso, fale com um administrador do sistema para ajustarem o seu acesso — não tente contornar a restrição por outro login.',
    actions: [],
  },
  {
    id: 'adm-seguranca',
    keywords: [
      'seguranca',
      'boas praticas',
      'senha forte',
      'compartilhar',
      'compartilhar senha',
      'sessao',
      'sessao ativa',
      'lgpd',
      'dados pessoais',
    ],
    answer:
      'Boas práticas de segurança: use uma senha longa e única (nunca a mesma de outros sistemas), mantenha o segundo fator ativo, não compartilhe a sua conta e não anote senhas em lugares acessíveis. Prefira acessar de um computador confiável, bloqueie a tela ao se ausentar e faça logout em máquinas compartilhadas. Aqui os dados pessoais são protegidos (LGPD) e o acesso é auditado.',
    actions: [],
  },
  {
    id: 'adm-suporte',
    keywords: ['suporte', 'ajuda', 'administrador', 'falar com alguem', 'ti', 'problema', 'erro', 'travou'],
    answer:
      'Se algo travar ou você precisar de um ajuste de acesso, procure a equipe responsável / o administrador do sistema informando o módulo, o que você tentava fazer e, se possível, o horário. Assim fica mais rápido identificar e resolver.',
    actions: [],
  },
  {
    id: 'adm-agradecimento',
    keywords: ['obrigad', 'valeu', 'brigad', 'agradeco', 'muito obrigado'],
    answer:
      'Fico feliz em ajudar! Cuide bem dos dados e da sua conta por aqui. Qualquer outra dúvida sobre o acesso ou os módulos, é só chamar.',
    actions: [],
  },
  {
    id: 'adm-senha-forte',
    keywords: [
      'senha forte',
      'criar senha',
      'criar uma senha',
      'requisitos',
      'minimo de caracteres',
      'minimo',
      'caracteres',
      'senha segura',
      'dica de senha',
      'como criar',
    ],
    answer:
      'Use uma senha longa — no mínimo 8 caracteres, de preferência bem mais — misturando letras maiúsculas e minúsculas, números e um símbolo. O ideal é uma frase-senha fácil de lembrar e difícil de adivinhar. Nunca reutilize a senha de outros sistemas e não anote em lugares acessíveis.',
    actions: [],
  },
  {
    id: 'adm-politica-uso',
    keywords: ['politica de uso', 'politica', 'termos', 'aceitar', 'aceite', 'concordo', 'aceito'],
    answer:
      'A política de uso reúne as regras de utilização do Console e da plataforma PETBEA — inclusive o que pode e o que não pode ser feito com os dados pessoais, que são protegidos pela LGPD. Ao marcar o aceite, você declara que leu os Termos de Uso e a Política de Privacidade, e esse aceite fica registrado na auditoria.',
    actions: [],
  },
  {
    id: 'adm-convite',
    keywords: [
      'convite',
      'convite expirou',
      'link expirou',
      'link do convite',
      'nao recebi o convite',
      'link invalido',
      'link nao funciona',
    ],
    answer:
      'Se o link do convite expirou ou não funcionou, peça um novo convite ao administrador do sistema — cada link é de uso único e expira rápido. Enquanto a validade não vencer, abra-o no mesmo navegador e conclua o primeiro acesso.',
    actions: [],
  },
  {
    id: 'adm-acesso-ajuda',
    keywords: [
      'nao consigo avancar',
      'nao avanca',
      'nao aceita minha senha',
      'nao salva',
      'nao vai',
      'nao funciona',
      'deu erro ao salvar',
    ],
    answer:
      'Se algo travar ou a senha não for aceita, confira se ela tem o mínimo de 8 caracteres e se a confirmação está exatamente igual. Depois, recarregue a página e refaça o processo. Se persistir, procure o administrador do sistema informando o que você estava tentando fazer.',
    actions: [],
  },
];

export const beaaAdminFallback = {
  id: 'adm-fallback',
  keywords: [],
  answer:
    'Ainda não tenho a resposta para isso por aqui. Mas posso te orientar sobre o acesso (primeiro acesso, senha e segundo fator), explicar os módulos do Console, falar do PETBEA e lembrar as boas práticas de segurança. Se precisar de algo específico, procure um administrador do sistema.',
  actions: [],
};